module.exports = __webpack_public_path__ + "static/media/success.20fe230b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/success.png
// module id = 451
// module chunks = 0